import React from 'react';

import MC_OPEN from './img/mc_lid_open.svg';
import GEL_BOX_CLOSE_IMG from './img/mc_lid_close.svg';
import GEL_POS_CONTROLS_IMG from './img/mc_controls.svg';
import EJECT_GEL_IMG from './img/gelbox_eject_gel.svg';

export function useGelboxTooltipControls() {

  const getControlItems = (props) => {
    const newControlItems = [];

    if (!props.open) {
      newControlItems.push({
        onClick: props.toggleLid,
        image: MC_OPEN,
      });
    } else {
      newControlItems.push({
        onClick: props.toggleLid,
        image: GEL_BOX_CLOSE_IMG,
      });
    }

    if (props.containsGel) {

      if (props.open) {
        newControlItems.push({
          onClick: props.onEjectGel,
          image: EJECT_GEL_IMG,
        });
      }

      newControlItems.push({
        onClick: props.openShowOrientationModal,
        image: GEL_POS_CONTROLS_IMG,
      });
    }

    return newControlItems;
  };

  return {getControlItems};
}
